import { render, staticRenderFns } from "./layoutGlobalMenu.vue?vue&type=template&id=2f0eda67&scoped=true"
import script from "./layoutGlobalMenu.vue?vue&type=script&lang=js"
export * from "./layoutGlobalMenu.vue?vue&type=script&lang=js"
import style0 from "./layoutGlobalMenu.vue?vue&type=style&index=0&id=2f0eda67&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0eda67",
  null
  
)

export default component.exports